import { render, staticRenderFns } from "./TitleHero.vue?vue&type=template&id=4520ad26&"
import script from "./TitleHero.vue?vue&type=script&lang=js&"
export * from "./TitleHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports